import { useEffect } from 'react';
import { UseMutationObserver } from './types';

const useMutationObserver: UseMutationObserver = (ref, callback, options) => {
  useEffect(() => {
    // Ensure the ref is attached to a DOM element
    if (!ref.current) return;

    const observer = new MutationObserver(callback);
    observer.observe(ref.current, options);

    // Clean up the observer when the component unmounts or dependencies change
    // eslint-disable-next-line consistent-return
    return () => observer.disconnect();
  }, [ref, callback, options]); // Re-run effect if ref, callback, or options change
};

export default useMutationObserver;
